module.exports = __webpack_public_path__ + "assets/img/networkAnalysis.5657fec9.svg";